module.exports = __webpack_public_path__ + "img/Intranet_Head2_1.c96e380d.png";